<template>
  <div class="push-notification-overlay">
    <div class="push-notification-modal">
      <div class="content">
        <img src="@/assets/push-notifications/popup-image.svg" class="popup-illustration" alt="" />
        <h2 class="popup-title margin-bottom-xl">להיות יותר על זה!</h2>
        <p class="ri-body body-text">
          אפשר לשלוח לך נוטיפיקציות בטלפון עם <span class="nowrap">עדכון על</span>
          <span class="nowrap">המצב החודשי?</span>
          זה מאוד עוזר ללקוחות שלנו
          <span class="bold-text"><span class="nowrap">להיות על</span> זה ולנצח את החודש.</span>
        </p>
        <p class="ri-body">
          אם זה נשמע לך טוב, נצטרך אישור בהודעה שתקפוץ במכשיר שלך.
        </p>
      </div>
      <div class="actions">
        <riseup-button
          class="start-button"
          color="green"
          @click="handleAccept"
          title="נשמע טוב!"
        />
        <div class="not-interested" @click="handleReject">אולי בפעם אחרת</div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseUI from '@riseupil/base-ui';
import Segment from '@/Segment';
import mobileMessagesUtils from '@/utils/mobileMessagesUtils';
import pushNotificationConsts from '@/constants/push-notifications';

export default {
  name: 'PushNotificationPermissionPopup',
  components: {
    RiseupButton: BaseUI.RiseupButton,
  },
  methods: {
    handleAccept() {
      Segment.trackUserInteraction('PushNotificationPermissionPopup_Accepted');
      localStorage.setItem(pushNotificationConsts.PUSH_NOTIFICATION_DECISION_KEY, 'accepted');
      mobileMessagesUtils.dispatchMessageToMobile(
        mobileMessagesUtils.MOBILE_MESSAGES_NAME.REQUEST_PUSH_NOTIFICATION_PERMISSION,
        {},
      );

      this.$emit('close');
    },
    handleReject() {
      Segment.trackUserInteraction('PushNotificationPermissionPopup_Rejected');
      localStorage.setItem(pushNotificationConsts.PUSH_NOTIFICATION_DECISION_KEY, 'rejected');
      localStorage.setItem(pushNotificationConsts.PUSH_NOTIFICATION_REJECTION_DATE_KEY, new Date().toISOString());
      this.$emit('close');
    },
  },
  created() {
    Segment.trackUserInteraction('PushNotificationPermissionPopup_Viewed');
  },
};
</script>

<style scoped lang="scss">
@import '~@riseupil/base-ui/src/scss/riseup-colors';

.push-notification-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  z-index: 9999;
}

.push-notification-modal {
  background-color: $riseup-beige;
  border-radius: 24px 24px 0 0;
  padding: 40px 30px 32px;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 100%;
  max-width: 460px;

  .content {
    text-align: center;
    color: $riseup-dark_green;

    .popup-illustration {
      width: 200px;
      margin-bottom: 24px;
    }

    .popup-title {
      margin: 0 auto;
      color: $riseup-green;
      font-family: SimplerProBold, SimplerPro, sans-serif;
      font-size: 40px;
      font-weight: bold;
      line-height: 1.1;
    }

    p {
      margin-bottom: 12px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .body-text {
      .line {
        display: block;
      }

      .bold-text {
        font-weight: bold;
      }

      .nowrap {
        white-space: nowrap;
      }
    }
  }

  .actions {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .not-interested {
      cursor: pointer;
      color: $riseup-dark_green;
      font-size: 16px;
      font-weight: 600;
      text-align: center;
      padding: 8px;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
